import { ref, onMounted, computed, watch, nextTick } from 'vue';
import Sidebar from '@/components/Sidebar.vue';
import Header from '@/components/HeaderDashboard.vue';
import Swal from 'sweetalert2';
import { hasPermission } from '@/store/userStore';
import { EquivalenteService } from '@/services/EquivalenteService';
import { RepuestoService } from '@/services/RepuestoService';
import { PERMISSIONS } from '@/constants/permissions';
import { DepartamentoService } from '@/services/DepartamentoService';
import { CategoriaService } from '@/services/CategoriaService';
import { AIService } from '@/services/AIService';
import { removeBackground } from '@imgly/background-removal';
import { PlusIcon, EditIcon, TrashIcon, SearchIcon, ChevronLeftIcon, CornerDownRightIcon, LayersIcon, GridIcon, CheckIcon, ChevronRightIcon, ChevronDownIcon, XIcon, ImageIcon, VideoIcon, CameraIcon, DownloadIcon, FileTextIcon, GripVerticalIcon, RepeatIcon, Wand2Icon, Loader2Icon, ChevronUpIcon } from 'lucide-vue-next';
import draggable from 'vuedraggable';
const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer);
        toast.addEventListener('mouseleave', Swal.resumeTimer);
    }
});
export default {
    name: 'Equivalentes',
    components: { Sidebar, Header, PlusIcon, EditIcon, TrashIcon, SearchIcon, ChevronLeftIcon, CornerDownRightIcon, LayersIcon, GridIcon, ChevronRightIcon, ChevronDownIcon, ChevronUpIcon, XIcon, ImageIcon, VideoIcon, CameraIcon, DownloadIcon, FileTextIcon, GripVerticalIcon, RepeatIcon, draggable, Wand2Icon, Loader2Icon, CheckIcon },
    setup() {
        const equivalentes = ref([]);
        const repuestos = ref([]);
        const isLoading = ref(false);
        const isSubmitting = ref(false);
        const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
        const searchQuery = ref('');
        const searchRepuestoText = ref('');
        const showRepuestoDropdown = ref(false);
        const filterType = ref('ambos');
        const selectedLetter = ref(null);
        const ultimoCodigo = ref('');
        const inlineEditing = ref({ itemId: null, isReplica: false, field: null });
        const inlineEditValue = ref(null);
        const inlineEditLoading = ref(false);
        const totalPages = ref(1);
        const totalCount = ref(0);
        const currentPage = ref(1);
        const itemsPerPage = ref(10);
        const departamentos = ref([]);
        const todasCategorias = ref([]);
        const filterDepartamentoId = ref(null);
        const filterCategoriaId = ref(null);
        const searchFilterDep = ref('');
        const showFilterDeps = ref(false);
        const searchFilterCat = ref('');
        const showFilterCats = ref(false);
        const filteredFilterDepsList = computed(() => {
            let deps = departamentos.value;
            if (searchFilterDep.value) {
                const q = searchFilterDep.value.toLowerCase();
                deps = deps.filter(d => d.nombre.toLowerCase().includes(q));
            }
            return deps.map(d => {
                if (!searchFilterDep.value)
                    return { ...d, highlightedNombre: d.nombre };
                const regex = new RegExp(`(${searchFilterDep.value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
                const highlightedNombre = d.nombre.replace(regex, `<mark>$1</mark>`);
                return { ...d, highlightedNombre };
            });
        });
        const filteredFilterCatsList = computed(() => {
            if (!filterDepartamentoId.value)
                return [];
            let cats = todasCategorias.value.filter(c => c.departamentoID === filterDepartamentoId.value && c.estado !== false);
            if (searchFilterCat.value) {
                const q = searchFilterCat.value.toLowerCase();
                cats = cats.filter(c => c.nombre.toLowerCase().includes(q));
            }
            return cats.map(c => {
                if (!searchFilterCat.value)
                    return { ...c, highlightedNombre: c.nombre };
                const regex = new RegExp(`(${searchFilterCat.value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
                const highlightedNombre = c.nombre.replace(regex, `<mark>$1</mark>`);
                return { ...c, highlightedNombre };
            });
        });
        const onFilterDepartamentoChange = () => {
            filterCategoriaId.value = null;
            searchFilterCat.value = '';
            loadData();
        };
        const selectFilterDep = (dep) => {
            filterDepartamentoId.value = dep.departamentoID;
            searchFilterDep.value = dep.nombre;
            showFilterDeps.value = false;
            onFilterDepartamentoChange();
        };
        const clearFilterDep = () => {
            filterDepartamentoId.value = null;
            searchFilterDep.value = '';
            showFilterDeps.value = false;
            onFilterDepartamentoChange();
        };
        const onBlurFilterDep = () => {
            setTimeout(() => {
                showFilterDeps.value = false;
                if (searchFilterDep.value.trim() === '') {
                    filterDepartamentoId.value = null;
                    onFilterDepartamentoChange();
                }
                else {
                    const selected = departamentos.value.find(d => d.departamentoID === filterDepartamentoId.value);
                    if (selected) {
                        searchFilterDep.value = selected.nombre;
                    }
                    else {
                        searchFilterDep.value = '';
                        filterDepartamentoId.value = null;
                        onFilterDepartamentoChange();
                    }
                }
            }, 150);
        };
        const selectFilterCat = (cat) => {
            filterCategoriaId.value = cat.categoriaID;
            searchFilterCat.value = cat.nombre;
            showFilterCats.value = false;
            loadData();
        };
        const clearFilterCat = () => {
            filterCategoriaId.value = null;
            searchFilterCat.value = '';
            showFilterCats.value = false;
            loadData();
        };
        const onBlurFilterCat = () => {
            setTimeout(() => {
                showFilterCats.value = false;
                if (searchFilterCat.value.trim() === '') {
                    filterCategoriaId.value = null;
                }
                else {
                    const selected = todasCategorias.value.find(c => c.categoriaID === filterCategoriaId.value);
                    if (selected) {
                        searchFilterCat.value = selected.nombre;
                    }
                    else {
                        searchFilterCat.value = '';
                        filterCategoriaId.value = null;
                    }
                }
            }, 150);
        };
        const isModalOpen = ref(false);
        const isEditing = ref(false);
        const isProcessingIA = ref(false);
        const removeGreen = ref(localStorage.getItem('autoRecorte') !== 'false');
        watch(removeGreen, (val) => {
            localStorage.setItem('autoRecorte', val.toString());
        });
        // Export Excel State
        const isExportModalOpen = ref(false);
        const isExporting = ref(false);
        const availableColumns = ref([
            { id: 1, name: "Repuesto" },
            { id: 2, name: "Código Equivalente" },
            { id: 4, name: "Stock Exp." },
            { id: 5, name: "Stock Plus" },
            { id: 6, name: "Stock Mega" },
            { id: 7, name: "Stock Total" }
        ]);
        const exportConfig = ref({
            format: 'excel',
            filterType: 'ambos',
            selectedColumns: ["Repuesto", "Código Equivalente", "Stock Exp.", "Stock Plus", "Stock Mega", "Stock Total"],
            sortColumn: "Repuesto",
            sortDirection: "asc"
        });
        const form = ref({
            id: 0,
            repuestoId: 0,
            versionModelo: '',
            codigoEquivalente: '',
            expless: 0,
            plus: 0,
            mega: 0,
            items: [],
            imagenes: [],
            video: null
        });
        const baseCode = computed(() => {
            if (!form.value.items || form.value.items.length === 0)
                return '';
            const fullCode = form.value.items[0].codigoEquivalente || '';
            return fullCode.slice(0, -1);
        });
        const imagePreviews = ref([]);
        const videoPreview = ref(null);
        const imagenesAEliminar = ref([]);
        const eliminarVideo = ref(false);
        const generateUniqueFileName = (file) => {
            const extension = file.name.split('.').pop();
            const timestamp = Date.now();
            const random = Math.floor(Math.random() * 1000);
            return `${timestamp}_${random}.${extension}`;
        };
        const handleImageUpload = async (e) => {
            const files = Array.from(e.target.files);
            const remaining = 6 - imagePreviews.value.length;
            const toAdd = files.slice(0, remaining);
            if (!toAdd.length)
                return;
            if (removeGreen.value) {
                isProcessingIA.value = true;
            }
            for (const file of toAdd) {
                let finalFile = file;
                if (removeGreen.value) {
                    try {
                        const processedBlob = await AIService.removeBackground(file);
                        const newName = generateUniqueFileName(file).replace(/\.[^/.]+$/, "") + ".webp";
                        finalFile = new File([processedBlob], newName, { type: 'image/webp' });
                    }
                    catch (err) {
                        console.error("AI Background Removal Error:", err);
                        Swal.fire('Atención', 'Hubo un error al extraer el fondo. Se subirá la imagen original.', 'warning');
                        const newName = generateUniqueFileName(file);
                        finalFile = new File([file], newName, { type: file.type });
                    }
                }
                else {
                    const newName = generateUniqueFileName(file);
                    finalFile = new File([file], newName, { type: file.type });
                }
                const url = URL.createObjectURL(finalFile);
                imagePreviews.value.push({ url, file: finalFile });
                form.value.imagenes.push(finalFile);
            }
            isProcessingIA.value = false;
            if (e.target)
                e.target.value = '';
        };
        const removeImage = (index) => {
            const item = imagePreviews.value[index];
            if (item.file) {
                const fileIndex = form.value.imagenes.indexOf(item.file);
                if (fileIndex > -1)
                    form.value.imagenes.splice(fileIndex, 1);
                URL.revokeObjectURL(item.url);
            }
            else if (item.mediaId !== undefined) {
                imagenesAEliminar.value.push(item.mediaId);
            }
            imagePreviews.value.splice(index, 1);
        };
        const handleVideoUpload = (e) => {
            const file = e.target.files[0];
            if (file) {
                const newName = generateUniqueFileName(file);
                const renamedFile = new File([file], newName, { type: file.type });
                form.value.video = renamedFile;
                videoPreview.value = URL.createObjectURL(renamedFile);
            }
        };
        const removeVideo = () => {
            if (videoPreview.value && !videoPreview.value.startsWith('blob:')) {
                eliminarVideo.value = true;
            }
            form.value.video = null;
            videoPreview.value = null;
        };
        const loadData = async () => {
            isLoading.value = true;
            try {
                const [resEq, resRep, deps, cats] = await Promise.all([
                    EquivalenteService.getAll(searchQuery.value, currentPage.value, selectedLetter.value || "", filterType.value, filterDepartamentoId.value, filterCategoriaId.value),
                    RepuestoService.getAllRepuestos(),
                    DepartamentoService.getAll().catch(() => []),
                    CategoriaService.getAll().catch(() => [])
                ]);
                if (deps.length > 0)
                    departamentos.value = deps;
                if (cats.length > 0)
                    todasCategorias.value = cats;
                if (resEq.exito && resEq.datos) {
                    equivalentes.value = resEq.datos.items || [];
                    totalPages.value = resEq.datos.totalPages || 1;
                    totalCount.value = resEq.datos.totalCount || 0;
                }
                else {
                    equivalentes.value = [];
                    totalPages.value = 1;
                    totalCount.value = 0;
                }
                repuestos.value = Array.isArray(resRep) ? resRep : resRep.datos || [];
            }
            catch (error) {
                console.error("Error loading data:", error);
            }
            finally {
                isLoading.value = false;
            }
        };
        const isEditingInline = (item, field) => {
            return inlineEditing.value.itemId === item.id && inlineEditing.value.isReplica === item.isReplica && inlineEditing.value.field === field;
        };
        const startInlineEdit = (item, field) => {
            if (!hasPermission(PERMISSIONS.EQUIVALENTES.EDIT)) {
                Toast.fire({ icon: 'warning', title: 'No tienes permisos para editar stock' });
                return;
            }
            inlineEditing.value = { itemId: item.id, isReplica: item.isReplica, field };
            inlineEditValue.value = item[field];
        };
        const adjustInlineStock = async (delta) => {
            if (inlineEditValue.value === null || inlineEditValue.value === undefined)
                return;
            inlineEditValue.value = Math.max(0, inlineEditValue.value + delta);
            await saveInlineEdit();
        };
        // ── Always-visible stepper: guarda directamente sin click previo ──
        const stockSaving = ref(false);
        const updateStock = async (item, field, newVal) => {
            if (!hasPermission(PERMISSIONS.EQUIVALENTES.EDIT)) {
                Toast.fire({ icon: 'warning', title: 'Sin permiso para editar stock' });
                return;
            }
            const val = Math.max(0, Math.round(newVal));
            if (isNaN(val) || val === item[field])
                return;
            stockSaving.value = true;
            try {
                const parentId = item.isReplica ? item.parentId : item.id;
                const res = await EquivalenteService.getById(parentId);
                if (!res.exito || !res.datos)
                    throw new Error('No se pudo obtener equivalente');
                const eqData = res.datos;
                if (item.isReplica) {
                    const rep = eqData.replicas.find((r) => r.id === item.id);
                    if (rep)
                        rep[field] = val;
                }
                else {
                    eqData[field] = val;
                }
                const fd = new FormData();
                fd.append('Id', eqData.id.toString());
                fd.append('RepuestoId', eqData.repuestoId.toString());
                fd.append('VersionModelo', eqData.versionModelo || 'N/A');
                fd.append('CodigoEquivalente', eqData.codigoEquivalente || '');
                fd.append('Expless', eqData.expless.toString());
                fd.append('Plus', eqData.plus.toString());
                fd.append('Mega', eqData.mega.toString());
                fd.append('EliminarVideo', 'false');
                if (eqData.replicas?.length > 0) {
                    eqData.replicas.forEach((rep, i) => {
                        fd.append(`Replicas[${i}].Id`, (rep.id || 0).toString());
                        fd.append(`Replicas[${i}].VersionModelo`, rep.versionModelo || eqData.versionModelo || 'N/A');
                        fd.append(`Replicas[${i}].CodigoEquivalente`, rep.codigoEquivalente || '');
                        fd.append(`Replicas[${i}].Expless`, rep.expless.toString());
                        fd.append(`Replicas[${i}].Plus`, rep.plus.toString());
                        fd.append(`Replicas[${i}].Mega`, rep.mega.toString());
                    });
                }
                await EquivalenteService.update(eqData.id, fd);
                // actualizar localmente sin recargar
                item[field] = val;
                Toast.fire({ icon: 'success', title: 'Stock actualizado' });
            }
            catch (e) {
                Toast.fire({ icon: 'error', title: e.message || 'Error al guardar' });
            }
            finally {
                stockSaving.value = false;
            }
        };
        const cancelInlineEdit = () => {
            inlineEditing.value = { itemId: null, isReplica: false, field: null };
            inlineEditValue.value = null;
        };
        const saveInlineEdit = async () => {
            if (inlineEditValue.value === null || inlineEditValue.value === undefined || isNaN(inlineEditValue.value) || inlineEditValue.value < 0) {
                Toast.fire({ icon: 'error', title: 'Ingresa un stock válido (0 o mayor)' });
                return;
            }
            const { itemId, isReplica, field } = inlineEditing.value;
            if (!itemId || !field)
                return;
            const item = processedEquivalentes.value.find((i) => i.id === itemId && i.isReplica === isReplica);
            if (!item) {
                cancelInlineEdit();
                return;
            }
            const stockNum = Number(inlineEditValue.value);
            if (stockNum === item[field]) {
                cancelInlineEdit();
                return;
            }
            inlineEditLoading.value = true;
            try {
                const parentId = isReplica ? item.parentId : item.id;
                const res = await EquivalenteService.getById(parentId);
                if (!res.exito || !res.datos) {
                    Toast.fire({ icon: 'error', title: 'Error al obtener equivalente' });
                    inlineEditLoading.value = false;
                    return;
                }
                const eqData = res.datos;
                if (isReplica) {
                    const replicaToUpdate = eqData.replicas.find((r) => r.id === item.id);
                    if (replicaToUpdate)
                        replicaToUpdate[field] = stockNum;
                }
                else {
                    eqData[field] = stockNum;
                }
                const formData = new FormData();
                formData.append('Id', eqData.id.toString());
                formData.append('RepuestoId', eqData.repuestoId.toString());
                formData.append('VersionModelo', eqData.versionModelo || 'N/A');
                formData.append('CodigoEquivalente', eqData.codigoEquivalente || '');
                formData.append('Expless', eqData.expless.toString());
                formData.append('Plus', eqData.plus.toString());
                formData.append('Mega', eqData.mega.toString());
                formData.append('EliminarVideo', 'false');
                if (eqData.replicas && eqData.replicas.length > 0) {
                    for (let i = 0; i < eqData.replicas.length; i++) {
                        const rep = eqData.replicas[i];
                        formData.append(`Replicas[${i}].Id`, (rep.id || 0).toString());
                        formData.append(`Replicas[${i}].VersionModelo`, rep.versionModelo || eqData.versionModelo || 'N/A');
                        formData.append(`Replicas[${i}].CodigoEquivalente`, rep.codigoEquivalente || '');
                        formData.append(`Replicas[${i}].Expless`, rep.expless.toString());
                        formData.append(`Replicas[${i}].Plus`, rep.plus.toString());
                        formData.append(`Replicas[${i}].Mega`, rep.mega.toString());
                        formData.append(`Replicas[${i}].Estado`, 'true');
                    }
                }
                const updateRes = await EquivalenteService.update(eqData.id, formData);
                if (updateRes.exito) {
                    Toast.fire({ icon: 'success', title: 'Stock actualizado correctamente' });
                    await loadData();
                    cancelInlineEdit();
                }
                else {
                    Toast.fire({ icon: 'error', title: updateRes.errores?.join(', ') || 'No se pudo actualizar' });
                }
            }
            catch (err) {
                Toast.fire({ icon: 'error', title: err.message || 'Error al actualizar' });
            }
            finally {
                inlineEditLoading.value = false;
            }
        };
        const getRepuestoNombre = (id) => {
            const rep = repuestos.value.find(r => r.repuestoID === id);
            return rep ? rep.nombre : '—';
        };
        const processedEquivalentes = computed(() => {
            if (!Array.isArray(equivalentes.value))
                return [];
            let flatList = [];
            equivalentes.value.forEach((eq) => {
                flatList.push({ ...eq, isReplica: false });
                if (eq.replicas && Array.isArray(eq.replicas)) {
                    eq.replicas.forEach((rep) => {
                        flatList.push({
                            ...eq,
                            id: rep.id,
                            codigoEquivalente: rep.codigoEquivalente,
                            versionModelo: rep.versionModelo || eq.versionModelo,
                            estado: rep.estado,
                            expless: rep.expless,
                            plus: rep.plus,
                            mega: rep.mega,
                            isReplica: true,
                            parentId: eq.id
                        });
                    });
                }
            });
            const nombreRepuesto = (item) => (item.nombreRepuesto || repuestos.value.find(r => r.repuestoID === item.repuestoId)?.nombre || '').toLowerCase();
            const getSuffixWeight = (code) => {
                const c = (code || '').toUpperCase();
                if (c.endsWith('E'))
                    return 1;
                if (c.endsWith('S'))
                    return 2;
                if (c.endsWith('O'))
                    return 3;
                return 4;
            };
            flatList.sort((a, b) => {
                const cmp = nombreRepuesto(a).localeCompare(nombreRepuesto(b));
                if (cmp !== 0)
                    return cmp;
                const pIdA = a.isReplica ? a.parentId : a.id;
                const pIdB = b.isReplica ? b.parentId : b.id;
                if (pIdA !== pIdB)
                    return pIdA - pIdB;
                const cmpSuffix = getSuffixWeight(a.codigoEquivalente) - getSuffixWeight(b.codigoEquivalente);
                if (cmpSuffix !== 0)
                    return cmpSuffix;
                return (a.codigoEquivalente || '').localeCompare(b.codigoEquivalente || '');
            });
            let currentGroupIndex = 0;
            let currentParentId = null;
            flatList.forEach((item) => {
                const pId = item.isReplica ? item.parentId : item.id;
                if (currentParentId !== pId) {
                    currentParentId = pId;
                    currentGroupIndex++;
                }
                item.groupIndex = currentGroupIndex;
            });
            return flatList;
        });
        let debounceTimeout = null;
        watch([searchQuery, selectedLetter, filterDepartamentoId, filterCategoriaId, filterType], () => {
            currentPage.value = 1;
            clearTimeout(debounceTimeout);
            debounceTimeout = setTimeout(() => {
                loadData();
            }, 300);
        });
        watch(searchFilterDep, (newVal) => {
            if (newVal.trim() === '' && filterDepartamentoId.value !== null) {
                filterDepartamentoId.value = null;
                filterCategoriaId.value = null;
                searchFilterCat.value = "";
            }
        });
        watch(searchFilterCat, (newVal) => {
            if (newVal.trim() === '' && filterCategoriaId.value !== null) {
                filterCategoriaId.value = null;
            }
        });
        watch(currentPage, () => {
            loadData();
        });
        const filteredRepuestosForSelect = computed(() => {
            if (searchRepuestoText.value.length < 3)
                return [];
            const searchTerm = searchRepuestoText.value.toLowerCase();
            return repuestos.value
                .filter(r => String(r.nombre || '').toLowerCase().includes(searchTerm))
                .map(r => {
                const regex = new RegExp(`(${searchTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, "gi");
                const highlightedNombre = String(r.nombre || '').replace(regex, `<mark>$1</mark>`);
                return { ...r, highlightedNombre };
            })
                .sort((a, b) => String(a.nombre).localeCompare(String(b.nombre)));
        });
        let searchRepuestoTimeout = null;
        const onSearchRepuesto = () => {
            showRepuestoDropdown.value = true;
            if (searchRepuestoText.value.length >= 3) {
                if (searchRepuestoTimeout)
                    clearTimeout(searchRepuestoTimeout);
                searchRepuestoTimeout = setTimeout(async () => {
                    try {
                        const res = await RepuestoService.getAllRepuestos(searchRepuestoText.value);
                        repuestos.value = res;
                    }
                    catch (error) {
                        console.error("Error searching repuestos:", error);
                    }
                }, 500);
            }
            else if (searchRepuestoText.value.length === 0) {
                repuestos.value = [];
            }
        };
        const selectRepuesto = (repuesto) => {
            form.value.repuestoId = repuesto.repuestoID;
            searchRepuestoText.value = repuesto.nombre;
            showRepuestoDropdown.value = false;
        };
        const incrementCode = (code) => {
            if (!code)
                return 'EQ0001E';
            const match = code.match(/^EQ(\d+)([ESO])$/);
            if (match) {
                const numberStr = match[1];
                const suffix = match[2];
                const number = parseInt(numberStr);
                if (suffix === 'E')
                    return `EQ${numberStr}S`;
                if (suffix === 'S')
                    return `EQ${numberStr}O`;
                if (suffix === 'O') {
                    const nextNumber = number + 1;
                    return `EQ${nextNumber.toString().padStart(numberStr.length, '0')}E`;
                }
            }
            else {
                const numericMatch = code.match(/^([a-zA-Z]+)(\d+)$/);
                if (!numericMatch)
                    return code + 'E';
                const prefix = numericMatch[1];
                const numberStr = numericMatch[2];
                const nextNumber = parseInt(numberStr) + 1;
                return prefix + nextNumber.toString().padStart(numberStr.length, '0') + 'E';
            }
            return 'EQ0001E';
        };
        const recalculateCodes = () => {
            let currentCode = ultimoCodigo.value;
            form.value.items.forEach((item, index) => {
                if (index === 0) {
                    item.codigoEquivalente = currentCode;
                }
                else {
                    currentCode = incrementCode(currentCode);
                    item.codigoEquivalente = currentCode;
                }
            });
        };
        const addItem = () => {
            let lastCode = form.value.items.length > 0
                ? form.value.items[form.value.items.length - 1].codigoEquivalente
                : ultimoCodigo.value;
            const suffixes = ['E', 'S', 'O'];
            let currentCode = lastCode;
            if (form.value.items.length > 0) {
                while (!currentCode.endsWith('O')) {
                    currentCode = incrementCode(currentCode);
                }
                currentCode = incrementCode(currentCode);
            }
            suffixes.forEach((suffix, idx) => {
                form.value.items.push({
                    versionModelo: '',
                    codigoEquivalente: currentCode,
                    expless: 0,
                    plus: 0,
                    mega: 0,
                    suffixLabel: suffix === 'E' ? 'Original' : 'Réplica'
                });
                if (idx < 2)
                    currentCode = incrementCode(currentCode);
            });
        };
        const removeItem = (index) => {
            const groupStartIndex = Math.floor(index / 3) * 3;
            form.value.items.splice(groupStartIndex, 3);
            recalculateCodes();
        };
        const openModal = async (item = null) => {
            isEditing.value = !!item;
            isModalOpen.value = true;
            imagePreviews.value = [];
            videoPreview.value = null;
            imagenesAEliminar.value = [];
            eliminarVideo.value = false;
            if (item) {
                const parentEq = item.isReplica ? equivalentes.value.find((e) => e.id === item.parentId) : equivalentes.value.find((e) => e.id === item.id);
                if (!parentEq)
                    return;
                form.value = {
                    ...parentEq,
                    items: [],
                    imagenes: [],
                    video: null,
                    isReplica: false
                };
                form.value.items.push({
                    id: parentEq.id,
                    versionModelo: parentEq.versionModelo,
                    codigoEquivalente: parentEq.codigoEquivalente,
                    expless: parentEq.expless,
                    plus: parentEq.plus,
                    mega: parentEq.mega,
                    suffixLabel: 'Original',
                    isReplica: false
                });
                if (parentEq.replicas && parentEq.replicas.length > 0) {
                    parentEq.replicas.forEach((rep, idx) => {
                        const suffix = rep.codigoEquivalente?.slice(-1) || (idx === 0 ? 'S' : 'O');
                        const defaultLabel = suffix === 'S' ? 'Réplica 1' : (suffix === 'O' ? 'Réplica 2' : `Réplica ${idx + 1}`);
                        form.value.items.push({
                            id: rep.id,
                            versionModelo: rep.versionModelo || parentEq.versionModelo,
                            codigoEquivalente: rep.codigoEquivalente,
                            expless: rep.expless,
                            plus: rep.plus,
                            mega: rep.mega,
                            suffixLabel: defaultLabel,
                            isReplica: true
                        });
                    });
                }
                if (item.multiMedia) {
                    item.multiMedia.forEach(m => {
                        if (m.tipo === 'Imagen') {
                            imagePreviews.value.push({ url: m.url, mediaId: m.id });
                        }
                        else if (m.tipo === 'Video') {
                            videoPreview.value = m.url;
                        }
                    });
                }
                const rep = repuestos.value.find(r => r.repuestoID === item.repuestoId);
                searchRepuestoText.value = rep ? rep.nombre : '';
            }
            else {
                try {
                    const resUltimo = await EquivalenteService.getUltimoCodigo();
                    const rawCode = resUltimo.datos || '';
                    const codeMatch = rawCode.match(/[A-Z]{2}\d+/);
                    const lastCode = codeMatch ? codeMatch[0] : rawCode;
                    ultimoCodigo.value = incrementCode(lastCode);
                }
                catch (error) {
                    console.error("Error fetching latest code:", error);
                    ultimoCodigo.value = 'EQ0001';
                }
                form.value = {
                    id: 0,
                    repuestoId: 0,
                    items: [],
                    imagenes: [],
                    video: null
                };
                let currentCode = ultimoCodigo.value;
                ['E', 'S', 'O'].forEach((suffix, idx) => {
                    form.value.items.push({
                        versionModelo: '',
                        codigoEquivalente: currentCode,
                        expless: 0,
                        plus: 0,
                        mega: 0,
                        suffixLabel: suffix === 'E' ? 'Original' : (suffix === 'S' ? 'Réplica 1' : 'Réplica 2')
                    });
                    if (idx < 2)
                        currentCode = incrementCode(currentCode);
                });
                searchRepuestoText.value = '';
            }
        };
        const saveEquivalente = async () => {
            if (form.value.repuestoId === 0) {
                Swal.fire('Error', 'Debe seleccionar un repuesto', 'error');
                return;
            }
            if (form.value.items && form.value.items.length > 0) {
                form.value.items.forEach((item) => {
                    if (!item.versionModelo)
                        item.versionModelo = 'N/A';
                });
            }
            isSubmitting.value = true;
            try {
                let res;
                if (isEditing.value) {
                    const formData = new FormData();
                    formData.append('Id', form.value.id.toString());
                    formData.append('RepuestoId', form.value.repuestoId.toString());
                    if (form.value.items && form.value.items.length > 0) {
                        const parentItem = form.value.items[0];
                        formData.append('VersionModelo', parentItem.versionModelo);
                        formData.append('CodigoEquivalente', parentItem.codigoEquivalente || '');
                        formData.append('Expless', parentItem.expless.toString());
                        formData.append('Plus', parentItem.plus.toString());
                        formData.append('Mega', parentItem.mega.toString());
                        for (let i = 1; i < form.value.items.length; i++) {
                            const rep = form.value.items[i];
                            formData.append(`Replicas[${i - 1}].Id`, (rep.id || 0).toString());
                            formData.append(`Replicas[${i - 1}].VersionModelo`, rep.versionModelo || parentItem.versionModelo);
                            formData.append(`Replicas[${i - 1}].CodigoEquivalente`, rep.codigoEquivalente || '');
                            formData.append(`Replicas[${i - 1}].Expless`, rep.expless.toString());
                            formData.append(`Replicas[${i - 1}].Plus`, rep.plus.toString());
                            formData.append(`Replicas[${i - 1}].Mega`, rep.mega.toString());
                            formData.append(`Replicas[${i - 1}].Estado`, 'true');
                        }
                    }
                    if (form.value.imagenes && form.value.imagenes.length > 0) {
                        form.value.imagenes.forEach((file) => {
                            formData.append('Imagenes', file);
                        });
                    }
                    if (imagenesAEliminar.value.length > 0) {
                        imagenesAEliminar.value.forEach((id) => {
                            formData.append('ImagenesAEliminar', id.toString());
                        });
                    }
                    if (form.value.video) {
                        formData.append('Video', form.value.video);
                    }
                    formData.append('EliminarVideo', eliminarVideo.value.toString());
                    res = await EquivalenteService.update(form.value.id, formData);
                }
                else {
                    const payload = {
                        repuestoId: form.value.repuestoId,
                        items: form.value.items
                    };
                    res = await EquivalenteService.bulkCreate(payload);
                }
                if (res.exito) {
                    Toast.fire({ icon: 'success', title: 'Operación completada' });
                    isModalOpen.value = false;
                    await loadData();
                }
                else {
                    Swal.fire('Error', res.errores?.join(', ') || 'Error al guardar', 'error');
                }
            }
            catch (error) {
                console.error("Save Error:", error);
                const msg = error.response?.data?.mensaje || error.message || 'No se pudo guardar';
                Swal.fire('Error', msg, 'error');
            }
            finally {
                isSubmitting.value = false;
            }
        };
        const confirmDelete = async (id) => {
            const res = await Swal.fire({
                title: '¿Desea eliminar este equivalente?',
                text: "Esta acción no se puede deshacer",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3b82f6',
                cancelButtonColor: '#94a3b8',
                confirmButtonText: 'Sí, eliminar',
                cancelButtonText: 'Cancelar'
            });
            if (res.isConfirmed) {
                try {
                    const response = await EquivalenteService.delete(id);
                    if (response.exito) {
                        Toast.fire({ icon: 'success', title: 'El registro ha sido eliminado' });
                        await loadData();
                    }
                    else {
                        Swal.fire('Error', response.errores?.join(', ') || 'No se pudo eliminar', 'error');
                    }
                }
                catch (error) {
                    Swal.fire('Error', 'Fallo de comunicación', 'error');
                }
            }
        };
        const isLightboxOpen = ref(false);
        const lightboxItems = ref([]);
        const lightboxIndex = ref(0);
        const lightboxFilter = ref('Imagen');
        const filteredLightboxItems = computed(() => lightboxItems.value.filter(i => i.tipo === lightboxFilter.value));
        const setLightboxFilter = (filter) => {
            lightboxFilter.value = filter;
            lightboxIndex.value = 0;
        };
        const openLightbox = (item) => {
            if (!item.multiMedia || item.multiMedia.length === 0)
                return;
            lightboxItems.value = item.multiMedia.map(m => ({ url: m.url, tipo: m.tipo }));
            lightboxIndex.value = 0;
            lightboxFilter.value = item.multiMedia.some(m => m.tipo === 'Imagen') ? 'Imagen' : 'Video';
            isLightboxOpen.value = true;
        };
        const closeLightbox = () => {
            isLightboxOpen.value = false;
            lightboxItems.value = [];
        };
        const lightboxPrev = () => {
            lightboxIndex.value = (lightboxIndex.value - 1 + filteredLightboxItems.value.length) % filteredLightboxItems.value.length;
        };
        const lightboxNext = () => {
            lightboxIndex.value = (lightboxIndex.value + 1) % filteredLightboxItems.value.length;
        };
        const cameraOpen = ref(false);
        const cameraMode = ref('photo');
        const cameraFacing = ref('environment');
        const cameraVideo = ref(null);
        const cameraCanvas = ref(null);
        const isRecording = ref(false);
        let cameraStream = null;
        let mediaRecorder = null;
        let recordedChunks = [];
        const openCamera = async (mode) => {
            cameraMode.value = mode;
            cameraOpen.value = true;
            // Esperar a que Vue actualice el DOM
            await nextTick();
            try {
                if (cameraStream) {
                    cameraStream.getTracks().forEach(t => t.stop());
                    cameraStream = null;
                }
                try {
                    cameraStream = await navigator.mediaDevices.getUserMedia({
                        video: {
                            facingMode: { ideal: cameraFacing.value },
                            width: { ideal: 1920 },
                            height: { ideal: 1080 }
                        },
                        audio: mode === 'video'
                    });
                }
                catch (fallbackErr) {
                    console.warn("Fallo con resolución ideal de equivalentes, probando constraints básicas:", fallbackErr);
                    try {
                        cameraStream = await navigator.mediaDevices.getUserMedia({
                            video: { facingMode: { ideal: cameraFacing.value } },
                            audio: mode === 'video'
                        });
                    }
                    catch (lastErr) {
                        console.warn("Fallo con facingMode ideal, probando con video genérico:", lastErr);
                        cameraStream = await navigator.mediaDevices.getUserMedia({
                            video: true,
                            audio: mode === 'video'
                        });
                    }
                }
                if (cameraVideo.value) {
                    cameraVideo.value.srcObject = cameraStream;
                    cameraVideo.value.setAttribute("playsinline", "true");
                    cameraVideo.value.setAttribute("autoplay", "true");
                    try {
                        await cameraVideo.value.play();
                    }
                    catch (playError) {
                        console.error("Error al reproducir video en equivalentes:", playError);
                    }
                }
            }
            catch (err) {
                console.error("Error al acceder a la cámara en equivalentes:", err);
                Swal.fire({
                    title: 'Cámara no disponible',
                    text: 'No se pudo acceder a la cámara. Verifica los permisos del navegador o la conexión segura (HTTPS).',
                    icon: 'error',
                    confirmButtonText: 'Aceptar'
                });
                cameraOpen.value = false;
            }
        };
        const switchCamera = () => {
            cameraFacing.value = cameraFacing.value === 'environment' ? 'user' : 'environment';
            openCamera(cameraMode.value);
        };
        const closeCamera = () => {
            isRecording.value = false;
            if (mediaRecorder && mediaRecorder.state !== 'inactive') {
                try {
                    mediaRecorder.stop();
                }
                catch (recErr) {
                    console.error("Error al detener la grabación:", recErr);
                }
            }
            if (cameraStream) {
                cameraStream.getTracks().forEach(t => t.stop());
                cameraStream = null;
            }
            if (cameraVideo.value) {
                cameraVideo.value.srcObject = null;
            }
            cameraOpen.value = false;
        };
        const capturePhoto = () => {
            if (!cameraVideo.value || !cameraCanvas.value)
                return;
            const video = cameraVideo.value;
            const canvas = cameraCanvas.value;
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            const ctx = canvas.getContext('2d');
            if (!ctx)
                return;
            ctx.drawImage(video, 0, 0);
            canvas.toBlob(async (blob) => {
                if (!blob)
                    return;
                closeCamera();
                let finalBlob = blob;
                let format = 'image/jpeg';
                let ext = 'jpg';
                if (removeGreen.value) {
                    isProcessingIA.value = true;
                    try {
                        const config = { publicPath: 'https://staticimgly.com/@imgly/background-removal-data/1.7.0/dist/' };
                        finalBlob = await removeBackground(blob, config);
                        format = 'image/png';
                        ext = 'png';
                    }
                    catch (err) {
                        console.error("AI Background Removal Error:", err);
                        Swal.fire('Atención', 'Hubo un error al recortar el fondo con IA. Se usará la imagen original.', 'warning');
                    }
                    finally {
                        isProcessingIA.value = false;
                    }
                }
                const timestamp = Date.now();
                const file = new File([finalBlob], `camara_${timestamp}.${ext}`, { type: format });
                const url = URL.createObjectURL(file);
                imagePreviews.value.push({ url, file });
                form.value.imagenes.push(file);
            }, 'image/jpeg', 0.92);
        };
        const startRecording = () => {
            if (!cameraStream)
                return;
            recordedChunks = [];
            const mimeType = MediaRecorder.isTypeSupported('video/webm;codecs=vp9')
                ? 'video/webm;codecs=vp9'
                : 'video/webm';
            mediaRecorder = new MediaRecorder(cameraStream, { mimeType });
            mediaRecorder.ondataavailable = e => { if (e.data.size > 0)
                recordedChunks.push(e.data); };
            mediaRecorder.onstop = () => {
                const blob = new Blob(recordedChunks, { type: 'video/webm' });
                const timestamp = Date.now();
                const file = new File([blob], `video_${timestamp}.webm`, { type: 'video/webm' });
                form.value.video = file;
                videoPreview.value = URL.createObjectURL(file);
                closeCamera();
            };
            mediaRecorder.start();
            isRecording.value = true;
        };
        const stopRecording = () => {
            if (mediaRecorder && mediaRecorder.state !== 'inactive')
                mediaRecorder.stop();
            isRecording.value = false;
        };
        const openExportModal = () => {
            isExportModalOpen.value = true;
        };
        const closeExportModal = () => {
            isExportModalOpen.value = false;
        };
        const handleExport = async () => {
            isExporting.value = true;
            try {
                await EquivalenteService.exportReport({
                    search: searchQuery.value,
                    letter: selectedLetter.value || "",
                    filterType: exportConfig.value.filterType,
                    departamentoId: filterDepartamentoId.value,
                    categoriaId: filterCategoriaId.value,
                    selectedColumns: availableColumns.value
                        .map(c => c.name)
                        .filter(name => exportConfig.value.selectedColumns.includes(name)),
                    format: exportConfig.value.format,
                    sortColumn: exportConfig.value.sortColumn,
                    sortDirection: exportConfig.value.sortDirection
                });
                Toast.fire({
                    title: '¡Éxito!',
                    text: 'El reporte se ha generado correctamente.',
                    icon: 'success'
                });
                closeExportModal();
            }
            catch (error) {
                console.error("Export Error:", error);
                Swal.fire('Error', error.message || 'No se pudo generar el reporte', 'error');
            }
            finally {
                isExporting.value = false;
            }
        };
        onMounted(loadData);
        return {
            P: PERMISSIONS,
            can: hasPermission,
            hasPermission,
            equivalentes, repuestos, isLoading, isSubmitting, alphabet, searchQuery, selectedLetter, currentPage,
            searchRepuestoText, filteredRepuestosForSelect, onSearchRepuesto, selectRepuesto, showRepuestoDropdown,
            ultimoCodigo, isModalOpen, isEditing, removeGreen, form, filterType,
            getRepuestoNombre,
            getReplicaLabel: (code) => {
                if (!code)
                    return '';
                if (code.endsWith('E'))
                    return 'Original';
                if (code.endsWith('S') || code.endsWith('O'))
                    return 'Réplica';
                return '';
            },
            getMediaCount: (item, tipo) => {
                if (!item.multiMedia)
                    return 0;
                return item.multiMedia.filter((m) => m.tipo === tipo).length;
            },
            totalCount,
            totalPages,
            paginatedEquivalentes: computed(() => processedEquivalentes.value),
            filterByLetter: (l) => selectedLetter.value = l,
            resetFilter: () => { selectedLetter.value = null; searchQuery.value = ''; },
            prevPage: () => currentPage.value--,
            nextPage: () => currentPage.value++,
            openModal,
            closeModal: () => isModalOpen.value = false,
            addItem,
            removeItem,
            saveEquivalente,
            startInlineEdit,
            cancelInlineEdit,
            adjustInlineStock,
            updateStock,
            stockSaving,
            saveInlineEdit,
            isEditingInline,
            inlineEditValue,
            inlineEditLoading,
            confirmDelete,
            imagePreviews,
            videoPreview,
            handleImageUpload,
            removeImage,
            handleVideoUpload,
            removeVideo,
            isLightboxOpen,
            lightboxItems,
            lightboxIndex,
            lightboxFilter,
            filteredLightboxItems,
            openLightbox,
            closeLightbox,
            lightboxPrev,
            lightboxNext,
            setLightboxFilter,
            cameraOpen, cameraMode, cameraVideo, cameraCanvas, isRecording,
            openCamera, closeCamera, capturePhoto, startRecording, stopRecording, switchCamera,
            isExportModalOpen, isExporting, exportConfig, availableColumns,
            isProcessingIA,
            openExportModal, closeExportModal, handleExport,
            syncVersionModelo: (index) => {
                if (index % 3 === 0) {
                    const version = form.value.items[index].versionModelo;
                    if (form.value.items[index + 1])
                        form.value.items[index + 1].versionModelo = version;
                    if (form.value.items[index + 2])
                        form.value.items[index + 2].versionModelo = version;
                }
            },
            baseCode,
            filterDepartamentoId,
            filterCategoriaId,
            searchFilterDep,
            showFilterDeps,
            searchFilterCat,
            showFilterCats,
            filteredFilterDepsList,
            filteredFilterCatsList,
            selectFilterDep,
            clearFilterDep,
            onBlurFilterDep,
            selectFilterCat,
            clearFilterCat,
            onBlurFilterCat
        };
    }
};
